import { FormContainer } from '@/components/form/FormContainer';
import { CreationWrapper } from '@/layouts/CreationWrapper';
import { Button, Select, Space } from 'antd';
import { useState } from 'react';

export const DevGuide = () => {
  const [sample, setSample] = useState('form');
  const samplesList = [
    { label: 'Form', value: 'form' },
  ];
  const rawSchema = [
    {
      i18nTitle: 'config.instance.form.maxSize',
      title: 'Max Size',
      dataIndex: 'maxSize2',
      valueType: 'digit',
      width: 'sm',
    },
    {
      type: 'array',
      dataIndex: 'nodegroups',
      i18nTitle: '',
      title: '',
      fields: [
        [{
          i18nTitle: 'config.instance.form.desiredSize',
          title: 'Desired Size',
          dataIndex: 'desiredSize',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          i18nTitle: 'config.instance.form.minSize',
          title: 'Min Size',
          dataIndex: 'minSize',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          i18nTitle: 'config.instance.form.maxSize',
          title: 'Max Size',
          dataIndex: 'maxSize',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm: 8 },
        },
        {
          i18nTitle: 'config.instance.form.nodeType',
          title: 'Type',
          dataIndex: 'type',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm: 12 },
        },
        {
          i18nTitle: 'config.instance.form.diskSize',
          title: 'Disk',
          dataIndex: 'diskSize',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm: 12 },
        },]
      ],
    },
    {
      type: 'array',
      dataIndex: 'hadoop',
      fields: [
        [{
          i18nTitle: 'config.instance.form.replicas',
          title: 'Replicas',
          dataIndex: 'replicas',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          i18nTitle: 'config.instance.form.core',
          title: 'Core',
          dataIndex: 'core',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          i18nTitle: 'config.instance.form.memory',
          title: 'Memory',
          dataIndex: 'memory',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          i18nTitle: 'config.instance.form.version',
          title: 'Version',
          dataIndex: 'version',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
          fieldProps: {
            disabled: true,
          },
        },
        {
          i18nTitle: 'config.instance.form.dataDisk',
          title: 'Data Disk',
          dataIndex: 'dataDisk',
          valueType: 'digit',
          width: 'sm',
          colProps: { xs: 24, sm:8 },
        },
        {
          valueType: 'dependency',
          name: ['name'],
          columns: ({ name }) => {
            if (name === 'zookeeper') {
              return [{
                i18nTitle: 'config.instance.form.logDisk',
                title: 'Log Disk',
                dataIndex: 'logDisk',
                valueType: 'digit',
                width: 'sm',
                colProps: { xs: 24, sm:8 },
              }];
            } else {
              return [];
            }
          }
        },
        ]
      ],
    },
  ];
  const rawValue = {
    nodegroups: [
      {
        name: 'master',
        desiredSize: 3,
        minSize: 1,
        maxSize: 51,
      },
      {
        name: 'mysql',
        desiredSize: 3,
        minSize: 1,
        maxSize: 51,
      },
    ],
    hadoop: [
      {
        "name": "zookeeper",
        "replicas": 3,
        "core": "500m",
        "version": "5.2.1",
        "memory": "1Gi",
        "dataDisk": "1Gi",
        "logDisk": "20Gi"
      },
      {
        "name": "hadoop-hdfs-nn",
        "replicas": 2,
        "core": "2000m",
        "version": "2.7.5.2",
        "memory": "4Gi",
        "dataDisk": "10Gi"
      },
      {
        "name": "hadoop-hdfs-jn",
        "replicas": 3,
        "core": "1000m",
        "version": "2.7.5.2",
        "memory": "2Gi",
        "dataDisk": "10Gi"
      },
    ],
  };

  return (
    <CreationWrapper>
      <h1>Dev Guide</h1>
      <p>Here you can find the development guide</p>
      <Select
        defaultValue={samplesList[0]}
        style={{ width: 120 }}
        onChange={(value) => setSample(value)}
        options={samplesList}
      />
      {sample === 'form' && (
        <FormContainer
          initValue={rawValue}
          schema={rawSchema}
          onFinishCallback={(values) => console.log(values)}
          submitter={{
            render: (props, doms) => {
              console.log(props);
              return [
                <Button key="previous" onClick={() => console.log('Previous')}>
                  Previous Step
                </Button>,
                <Button key="rest" onClick={() => props.form?.resetFields()}>
                  Reset
                </Button>,
                <Button type="primary" key="submit" onClick={() => props.form?.submit?.()}>
                  Submit
                </Button>,
              ];
            },
          }}
        />
      )}
    </CreationWrapper>
  );
};